import { forwardRef } from 'react';
import { useFieldControlId, useResolvedAriaLabel } from './fieldControlContext';

const joinClassNames = (...classNames) => classNames.filter(Boolean).join(' ');

const SEARCH_INPUT_SIZE_CLASSES = {
  compact: 'ui-text-input--compact',
  standard: 'ui-search-input--standard',
};

const SearchInput = forwardRef(({
  className = '',
  size = 'compact',
  appearance = 'default',
  type = 'text',
  // Pulled out of the spread so a FormField caption can supply it. An explicit
  // id still wins.
  id,
  'aria-label': ariaLabel,
  ...props
}, ref) => {
  const controlId = useFieldControlId(id);
  // Same rule the other adopting primitives use: an aria-label that only repeats
  // the caption outranks and masks the association just built.
  const resolvedAriaLabel = useResolvedAriaLabel(ariaLabel, id);
  const sizeClassName = SEARCH_INPUT_SIZE_CLASSES[size] || SEARCH_INPUT_SIZE_CLASSES.compact;
  const appearanceClassName = appearance === 'silent' ? 'ui-search-input--silent' : '';

  return (
    <input
      ref={ref}
      id={controlId}
      type={type}
      aria-label={resolvedAriaLabel}
      className={joinClassNames(
        'ui-text-input ui-search-input',
        sizeClassName,
        appearanceClassName,
        className,
      )}
      {...props}
    />
  );
});

SearchInput.displayName = 'SearchInput';

export default SearchInput;
